import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import { ScientificName } from "../../../type/scientificName";
import ActionItem from "../../Global/ActionItem";
import ScientificNamesTooltip from "./ScientificNamesTooltip";
import { toast } from "react-toastify";
import WarningRedAlert from "../../ErrorAndAlert/WarningRedAlert";
import { defaultLang, secondLang } from "../../../utils";

const ScientificNameTableItem: React.FC<{
  names: ScientificName;
  fetchData: () => void;
  lastIndex: number;
}> = ({ names, fetchData: propFetchDta, lastIndex }) => {
  const { i18n, t } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);

  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/scientific_names/${names.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.The record deleted successfully")}`,
    true,
    true
  );
  useEffect(() => {
    if (deleteR !== null) {
      isShowDelete(false);
      propFetchDta();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (names.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(
        t("Message.You can’t delete the species. It is used in planting.")
      );
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };

  const name =
    names.species_name_transes[secondLang] === ""
      ? names.species_name_transes[defaultLang]
      : names.species_name_transes[secondLang];
  return (
    <Fragment>
      <TableCell align="left">
        {i18n.language === secondLang
          ? name
          : names.species_name_transes[defaultLang]}
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          {i18n.language === secondLang
            ? names.scientific_name_transes[0][secondLang] ||
              names.scientific_name_transes[0][defaultLang]
            : names.scientific_name_transes[0][defaultLang]}
          {names.scientific_name_transes.length > 1 && (
            <ScientificNamesTooltip names={names.scientific_name_transes} />
          )}
        </div>
      </TableCell>
      <TableCell align="right">
        <ActionItem
          delete={true}
          editLink={`/setting/scientific-names/edit-scientific-name/${names.slug}`}
          deleteAction={deleteAction}
          view=""
          viewLink=""
          historyLink=""
          viewHistory=""
        />
      </TableCell>
      {showDelete && (
        <WarningRedAlert
          type={t("Tree Species.Scientific name")}
          hide={hide}
          action={deleteItem}
          isDelete={true}
          isSignOut={false}
        />
      )}
    </Fragment>
  );
};

export default ScientificNameTableItem;
